import { type FC, type ReactElement } from 'react';
import { Tooltip, type TooltipProps } from '@material-ui/core';
import cx from 'classnames';

import { useStyles } from './useStyles';

export const CUSTOM_TOOLTIP_SIZE = {
  default: 'default',
  small: 'small',
} as const;
export type CustomTooltipSize = (typeof CUSTOM_TOOLTIP_SIZE)[keyof typeof CUSTOM_TOOLTIP_SIZE];

export interface CustomTooltipProps extends TooltipProps {
  className?: string;
  classes?: Record<string, string>;
  size?: CustomTooltipSize;
  fitContent?: boolean;
  children: ReactElement;
}

export const CustomTooltip: FC<CustomTooltipProps> = ({
  className,
  classes,
  size = CUSTOM_TOOLTIP_SIZE.default,
  fitContent = false,
  children,
  ...restProps
}) => {
  const styles = useStyles({ classes });
  return (
    <Tooltip
      classes={{
        tooltip: cx(styles.tooltip, className, {
          [styles.sizeSmall]: size === CUSTOM_TOOLTIP_SIZE.small,
          [styles.fitContent]: fitContent,
        }),
      }}
      arrow
      {...restProps}
    >
      {children}
    </Tooltip>
  );
};

CustomTooltip.displayName = 'CustomTooltip';
